import { render } from "./FormChangeEo.vue?vue&type=template&id=1252d556"
import script from "./FormChangeEo.vue?vue&type=script&lang=js"
export * from "./FormChangeEo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__